import { useContext } from "react";
import { LanguageContext } from "../contexts/LanguageContext";

function useLanguage() {
  return useContext(LanguageContext);
}

export default useLanguage;
